import { useMutation } from '@tanstack/react-query';
import { api } from '../lib/api';

export interface ImportRowError {
  row: number;
  message: string;
}

export interface ImportReport {
  total: number;
  inserted: number;
  updated: number;
  errors: ImportRowError[];
  dry_run: boolean;
}

export function usePeopleImport() {
  return useMutation({
    mutationFn: async (input: {
      csv: string;
      dry_run?: boolean;
      /** uuid attaches imports there, null imports unallocated, omitted follows the session scope. */
      mobilisation_id?: string | null;
    }) => {
      return api<ImportReport>('/api/people/import', {
        method: 'POST',
        body: JSON.stringify(input),
      });
    },
  });
}
